// extracted by mini-css-extract-plugin
export default {"s1":"RedStuff_s1__oQB7E","s2":"RedStuff_s2__rrCy-","s3":"RedStuff_s3__OV3+0"};